import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./realestate.css";
import HeroFooter from "../../components/footer";
import ScrollToTop from "./scrolltop";

const categories = [
  "Contract Management",
  "Foreign Collaborations",
  "Joint Ventures",
  "Corporate Law",
  "Information Technology",
  "Business Ventures",
  "MSME",
  "Start-up India Initiatives",
  "Property and Real Estate"
];

// Map each category to a custom slug
const categoryMapping = {
  "Contract Management": "contract",
  "Foreign Collaborations": "foreign",
  "Joint Ventures": "joint",
  "Corporate Law": "corporate",
  "Information Technology": "information",
  "Business Ventures": "buisness",
  "MSME": "msme",
  "Start-up India Initiatives": "startup",
  "Property and Real Estate": "realestate"
};

const ForeignCollaborations = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  const toggleSidebar = () => setSidebarOpen(prev => !prev);
  
  return (
    <div className="practice-page">
         <ScrollToTop/>
      <div className="mobile-menu-button" onClick={toggleSidebar}>
        <i className="fa fa-bars" aria-hidden="true"></i>
      </div>
      
      <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <h2 className="sidebar-title">Our Offerings</h2>
        <ul className="category-list">
          {categories.map((category, index) => (
            <li key={index} className={category === "Foreign Collaborations" ? "active" : ""}>
              <Link
                onClick={() => setSidebarOpen(false)}
                to={`/${categoryMapping[category]}`}
              >
                {category}
              </Link>
            </li>
          ))}
        </ul>
      </aside>
      
      <main className="conten">
        <h2>Foreign Collaborations</h2>
        <p className="intro">
          At InduratnaLaw, we help businesses build strong international alliances. Our foreign collaborations service facilitates cross-border legal partnerships that span regulatory compliance, dispute resolution, and strategic market entry.
        </p>
        <section className="details">
          <h3>Our Expertise</h3>
          <p>
            We provide holistic legal support for businesses aiming to expand globally. From drafting international contracts to ensuring compliance with foreign laws, our team handles the complexities of cross-border ventures with precision.
          </p>
          <h3>Key Services</h3>
          <ul>
            <li>International Contract Drafting and Review</li>
            <li>Legal Process Outsourcing</li>
            <li>Legal and Regulatory Compliance</li>
            <li>Dispute Resolution in a Global Context</li>
            <li>Cross-Border Transaction Support</li>
            <li>Strategic Market Entry Advisory</li>
          </ul>
          <h3>Why Choose InduratnaLaw?</h3>
          <p>
            Our deep knowledge of international law and local practices ensures that your global partnerships are not only secure but also positioned for long-term success.
          </p>
        </section>
      </main>
      <HeroFooter />
    </div>
  );
};

export default ForeignCollaborations;
